import React from "react";
import { Card, Button, Row, Col } from "antd";
import "./PendingCard.less";

const PendingCard = (props) => {
  return (
    <Card className='pending-card' loading={props.loading}>
      <div className='cover-image'>
        <img
          src={props.lectureImage}
          alt='Lecturer'
          className='lecturer-image'
        />
      </div>
      <Row className='card-content'>
        <Col span={16} className='details'>
          <div className='lecture-name'>
            <p className='label'>Subject name</p>
            <p className='value'>{props.subjectname}</p>
          </div>
          <div className='date-time'>
            <p className='label'>Due Date</p>
            <p className='value'>{props.duedate}</p>
          </div>
        </Col>
        <Col span={8} className='view-button-container'>
          <Button type='primary' className='view-button'>
            View
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default PendingCard;
